export default __webpack_public_path__ + "static/codoc-e2d0b6dee3f2b8014192ec7307d9351d.png";